import Pusher from 'pusher-js'
import { useRuntimeConfig } from '#app'; 

let pusher = null
let pusherToken = null

const getAuthToken = () => sessionStorage.getItem('token') || localStorage.getItem('token')
const getPusherRuntimeConfig = () => {
    const config = useRuntimeConfig();
    return {
        apiUrl: config.public.api_url,
        pusherKey: config.public.pusher_key,
        pusherCluster: config.public.pusher_cluster,
    };
};

const getOrCreatePusher = () => {
    const token = getAuthToken()
    if (!token) return null
    const { apiUrl, pusherKey, pusherCluster } = getPusherRuntimeConfig()

    if (pusher && pusherToken === token) {
        return pusher
    }

    if (pusher) {
        pusher.disconnect()
    }

    pusher = new Pusher(pusherKey, {
        cluster: pusherCluster,
        authEndpoint: `${apiUrl}/pusher/auth`,
        auth: {
            headers: {
                authorization: `Bearer ${token}`,
            },
        },
        forceTLS:true
    })
    pusherToken = token

    return pusher
}


export const usePusher = async () =>{

    const chatStore = useChatStore()
    const notificationStore = useNotificationStore()
    const userStore = useUserStore()
    // const {getList} = await useChat()
    
    const subscribeCommonChannel = async () => {
        const pusherClient = getOrCreatePusher()
        if (!pusherClient) {
            console.warn('Pusher subscribe skipped: missing auth token')
            return
        }

        const centralChannel = pusherClient.subscribe('presence-central')

        centralChannel.bind('notification',async (notification)=>{
            if(notification.user_id == userStore.profile.id){
                notificationStore.addNotification(notification)
            }
        })

        centralChannel.bind('subscribe-channel',async (data)=>{
            if(data.user_id == userStore.profile.id){
                subscribeSingleChannel(data.conversation_id)
                await getList()
            }
        })

        centralChannel.bind('unsubscribe-channel',async (data)=>{
            if(data.user_id == userStore.profile.id){
                unSubscribeSingleChannel(data.conversation_id)
                await getList()
                if(chatStore.current_conversation.id == data.conversation_id){
                    chatStore.setCurrentConversation(null)
                }
            }
        })

        centralChannel.bind('pusher:subscription_succeeded', (members) => {
            chatStore.setOnlineUsers(members.members)
        });

        centralChannel.bind('pusher:member_added', (member) => {
            chatStore.addOnlineUser(member)
          });
        
        centralChannel.bind('pusher:member_removed', (member) => {
            chatStore.removeOnlineUser(member)
          });
          
        centralChannel.bind('pusher:subscription_error', (status) => {
            console.error('Subscription error:', status);
          });

        console.log('subscribeCommonChannel',centralChannel)

    }

    const unSubscribeCommonChannel = async () => {
        if (!pusher) return
        pusher.unsubscribe('presence-central')
    }

    const subscribeToChannels = async (channels) => {
        const pusherClient = getOrCreatePusher()
        if (!pusherClient) {
            console.warn('Pusher channel subscribe skipped: missing auth token')
            return
        }

        await subscribeCommonChannel()

        channels.forEach(name => {
            console.log(`subscribing to ${name}`)
            let channel = pusherClient.subscribe(`private-${name}`)

            channel.bind('messages',async (message)=>{
                console.log('add message pusher:',message)
                await chatStore.addMessage(message)
            })

            channel.bind('delete-message',(data)=>{
                const {conversationId,messageId} = data
                chatStore.deleteMessage(conversationId,messageId)
            })

            channel.bind('update-message',(data)=>{
                console.log('update-message',data)
                const {conversation_id,message_id,message} = data
                chatStore.updateMessage(conversation_id,message_id,message)
            })

            channel.bind('user-typing', function(data) {
                handleUserTyping(channelName, data);
            });

        });

        return
    }

    const unsubscribeTochannels = async (channels) =>{
        if (!pusher) return

        if(channels.length <= 0) return

        channels.forEach(name => {
            pusher.unsubscribe(`private-${name}`);
        });

        return
    }

    const subscribeSingleChannel = async (channelName) => {
        const pusherClient = getOrCreatePusher()
        if (!pusherClient) {
            console.warn('Pusher single channel subscribe skipped: missing auth token')
            return
        }

        let channel = pusherClient.subscribe(`private-${channelName}`)
        
        channel.bind('messages',async (message)=>{
            await chatStore.addMessage(message)
        })
        
        channel.bind('delete-message',(data)=>{
            const {conversationId,messageId} = data
            chatStore.deleteMessage(conversationId,messageId)
        })
        
        channel.bind('update-message',(data)=>{
            const {conversation_id,message_id,message} = data
            chatStore.updateMessage(conversation_id,message_id,message)
        })
        
        channel.bind('user-typing', function(data) {
            handleUserTyping(channelName, data);
        });
        console.log('subscribeSingleChannel',channelName,channel)
        return
    }

    const unSubscribeSingleChannel = async (channelName) => {
        if (!pusher) return
        pusher.unsubscribe(`private-${channelName}`);
        return
    }

    const getList = async () => {
        try {
            const {data:list,message} = await useAxiosGet('chat/list')
            chatStore.setList(list)
            return list
        } catch (error) {
            console.log("Dashboard Error : ",error)
        }
    }

    return{
        subscribeCommonChannel,
        unSubscribeCommonChannel,
        subscribeToChannels,
        unsubscribeTochannels,
        subscribeSingleChannel,
        unSubscribeSingleChannel
    }

}
